import { ReceivedRejectEnum } from "../enum"

export const convertReceivedReject = (data: number) => {
  if (data === ReceivedRejectEnum.RECEIVED_REJECTED_ITEM) return "RECEIVED REJECTED ITEM"
  if (data === ReceivedRejectEnum.RECEIVED_REJECTED_MONEY) return "RECEIVED REJECTED MONEY"
  if (data === ReceivedRejectEnum.RECEIVED_REJECTED_ADJUSTMENT) return "RECEIVED REJECTED ADJUSTMENT"

  return "-"
}